/**
 * Resolve ENV variable from multiple environments (Vite, CRA / Node).
 * Falls back to empty string when not configured.
 */
export function getEnvVariable(env) {
    // Vite style
    const vite = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : undefined;
    if (vite && typeof vite[`VITE_${env}`] === 'string') {
        return vite[`VITE_${env}`];
    }
    // CRA/Node style (when bundled with tools that inject process.env)
    const procEnv = (typeof process !== 'undefined' ? process.env : undefined) || undefined;
    if (procEnv && typeof procEnv[`REACT_APP_${env}`] === 'string') {
        return procEnv[`REACT_APP_${env}`];
    }
    return '';
}
//# sourceMappingURL=env.js.map